module.exports = __webpack_public_path__ + "static/media/S2N13-4.5fe17a28.svg";